// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"df95f972955b0d66e0b7","883":"325919284d847f7869ad"}[chunkId] + ".js";
};